import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../../../localization/labels";
import { activeFilterPageInfo } from "../../../../../../services/FilteringUtils";
import LifeCycleClassDefinitionService from "../../../../../../services/LifeCycleClassDefinitionService";
import LifeCycleService from "../../../../../../services/LifeCycleService";
import LifeCycleStateTypeService from "../../../../../../services/LifeCycleStateTypeService";
import CommonUtil from "../../../../../../utils/CommonUtil";
import { constants } from "../../../../../../utils/Constants";
import PathUtil from "../../../../../../utils/PathUtil";
import RouteUtil from "../../../../../../utils/RouteUtil";
import {
  lifeCycleValidationRules as validationRules,
  validateEntity
} from "../../../../../../validators/validationRules";
import { paths } from "../../../../../paths";
import PageComponent from "../../../../page/PageComponent";
import LifeCycle from "./LifeCycle";

class LifeCycleContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.lifeCycleService = new LifeCycleService(this.keycloak);
    this.lifeCycleStateTypeService = new LifeCycleStateTypeService(
      this.keycloak
    );
    this.lifeCycleClassDefinitionService = new LifeCycleClassDefinitionService(
      this.keycloak
    );

    this.state = {
      id: this.resolveItemId(),
      lifeCycleStateTypes: [],
      disabled: true,
      disabledInitialState: false
    };
    this.state = this.initialState(this.props, this.state);
  }

  initialState = (props, state) => {
    if (state.id) {
      return {
        ...state,
        lifeCycle: { dateFromTo: {}, nextLifeCycles: [] },
        posibleNextLifeCycles: []
      };
    } else {
      return {
        ...state,
        lifeCycle: {
          lifeCycleStateType: { id: undefined },
          dateFromTo: {},
          nextLifeCycles: [],
          lifeCycleClassDefinition: {
            id: RouteUtil.getLocationParameter(
              props,
              "lifeCycleClassDiscriminatorId"
            )
          }
        },
        posibleNextLifeCycles: RouteUtil.getLocationParameter(
          props,
          "posibleNextLifeCycles"
        )
      };
    }
  };

  componentDidUpdate(prevProps) {
    const newId = this.resolveItemId();

    if (newId !== PathUtil.pathParameter(prevProps, "id")) {
      this.state.id = newId;

      this.setState(this.initialState(this.props, this.state));
      this.loadData();
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  loadData = () => {
    if (this.state.id) {
      this.loadLifeCycle(this.state.id);
    } else {
      this.setComponentTitle(labels.state);
      this.loadLifeCycleStateTypes();
    }
  };

  loadLifeCycle = id => {
    this.prepareCall(
      this.lifeCycleService.getEntityById(
        id,
        this.onLifeCycleLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  getComponentTitle = () => {
    return this.state.lifeCycle ? this.state.lifeCycle.name : labels.state;
  };

  onLifeCycleLoad = data => {
    this.setState({ lifeCycle: { ...data }, oldLifeCycle: { ...data } });
    this.setComponentTitle(this.state.lifeCycle.name, true);
    this.loadNextLifcycles();
    this.loadLifeCycleStateTypes();
  };

  loadLifeCycleStateTypes = () => {
    this.prepareCall(
      this.lifeCycleStateTypeService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onLifeCycleStateTypesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLifeCycleStateTypesLoad = data => {
    let lifeCycleStateTypes;
    const { lifeCycle } = this.state;
    let disabledInitialState = true;
    if (
      !lifeCycle.lifeCycleStateType.id ||
      lifeCycle.lifeCycleStateType.id !==
        constants.LIFE_CYCLE_STATE_TYPE_PROTECTED_INITIAL
    ) {
      lifeCycleStateTypes = data._embedded.content.filter(
        item => item.id !== constants.LIFE_CYCLE_STATE_TYPE_PROTECTED_INITIAL
      );
      disabledInitialState = false;
    } else {
      lifeCycleStateTypes = data._embedded.content;
    }
    this.setState({
      lifeCycleStateTypes: lifeCycleStateTypes,
      disabledInitialState: disabledInitialState
    });
  };

  loadNextLifcycles = () => {
    const url = this.state.lifeCycle._links.nextLifeCycles.href;
    this.prepareCall(
      this.lifeCycleService.getEntitiesWithParams(
        url,
        activeFilterPageInfo,
        undefined,
        this.onNextLifeCyclesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onNextLifeCyclesLoad = data => {
    const { lifeCycle, oldLifeCycle } = this.state;
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      lifeCycle.nextLifeCycles = [...dataContent];
      oldLifeCycle.nextLifeCycles = [...dataContent];
    } else {
      lifeCycle.nextLifeCycles = [];
      oldLifeCycle.nextLifeCycles = [];
    }
    this.setState({ lifeCycle, oldLifeCycle });
    this.loadLifeCycleClassDefinition();
  };

  loadLifeCycleClassDefinition = () => {
    const url = this.state.lifeCycle._links.lifeCycleClassDefinition.href;
    this.prepareCall(
      this.lifeCycleClassDefinitionService.getEntitiesByUrl(
        url,
        this.onLifeCycleClassDefinitionLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onLifeCycleClassDefinitionLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent?.[0]) {
      this.loadPossibleNextLifeCycles(dataContent[0]?._links.lifeCycles.href);
    }
  };

  loadPossibleNextLifeCycles = url => {
    this.prepareCall(
      this.lifeCycleService.getEntitiesWithParams(
        url,
        activeFilterPageInfo,
        undefined,
        this.onPossibleNextLifeCyclesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onPossibleNextLifeCyclesLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      this.setState({
        posibleNextLifeCycles: dataContent,
        disabled: false
      });
    }
    this.filterPossibleNextLifeCycles();
  };

  filterPossibleNextLifeCycles = () => {
    const lifeCycle = this.state.lifeCycle;
    const nextLifeCycles = lifeCycle.nextLifeCycles;
    const posibleNextLifeCycles = this.state.posibleNextLifeCycles;

    if (posibleNextLifeCycles) {
      //Remove current lifeCycle from possible next lifeCycles
      this._removeLifeCycle(lifeCycle.id, posibleNextLifeCycles);

      //Remove nextLifeCycles from posibleLifeCycles
      nextLifeCycles.forEach(nextLifeCycle => {
        this._removeLifeCycle(nextLifeCycle.id, posibleNextLifeCycles);
      });

      //Remove initial lifeCycles from posibleLifeCycles
      this._removeLifeCycle(
        constants.LIFE_CYCLE_STATE_TYPE_PROTECTED_INITIAL,
        posibleNextLifeCycles
      );
    }
  };

  _removeLifeCycle = (id, from) => {
    var removeIndex = from
      .map(function (lifeCycle) {
        return lifeCycle.id;
      })
      .indexOf(id);
    CommonUtil.removeFromArrayAtIndex(from, removeIndex);
  };

  onPosibleNextLifeCycleClick = lifeCycle => {
    //Move item from posibleNextLifeCycle to nextLifeCycle
    this._transitLifeCycle(
      lifeCycle,
      this.state.posibleNextLifeCycles,
      this.state.lifeCycle.nextLifeCycles
    );
  };

  onNextLifeCycleClick = lifeCycle => {
    //Move item from nextLifeCycle to posibleNextLifeCycle
    this._transitLifeCycle(
      lifeCycle,
      this.state.lifeCycle.nextLifeCycles,
      this.state.posibleNextLifeCycles
    );
  };

  _transitLifeCycle = (lifeCycle, from, to) => {
    const index = from.indexOf(lifeCycle);
    CommonUtil.removeFromArrayAtIndex(from, index);
    to.push(lifeCycle);

    this.setState({
      posibleNextLifeCycles: this.state.posibleNextLifeCycles,
      lifeCycle: this.state.lifeCycle
    });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.lifeCycle);
  };

  onChange = event => {
    var lifeCycle = this.state.lifeCycle;
    const path = event.target.id;
    CommonUtil.setDeepOnStringPath(lifeCycle, path, event.target.value);
    const disabled = !this.validator(lifeCycle);
    this.setState({
      lifeCycle: lifeCycle,
      disabled: disabled
    });
  };

  onSave = () => {
    const { lifeCycle, oldLifeCycle } = this.state;
    if (lifeCycle?.id) {
      this.prepareCall(
        this.lifeCycleService.patchEntity(
          lifeCycle,
          oldLifeCycle,
          this.onDataResponse,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    } else {
      this.prepareCall(
        this.lifeCycleService.postEntity(
          lifeCycle,
          this.onDataResponse,
          this.messageHandler.handleError,
          this.onSaveSuccessMessage
        )
      );
      this.performCalls();
    }
  };

  onDataResponse = data => {
    if (this.state.id) {
      this.loadLifeCycle(this.state.id);
    } else {
      const itemPath = PathUtil.adminItemsPath(
        { path: paths.LIFE_CYCLE },
        { path: paths.DETAIL, id: data.id }
      );
      this.changePath(itemPath, data.name);
    }
  };

  render() {
    return (
      <LifeCycle
        lifeCycle={this.state.lifeCycle}
        lifeCycleStateTypes={this.state.lifeCycleStateTypes}
        posibleNextLifeCycles={this.state.posibleNextLifeCycles}
        onPosibleNextLifeCycleClick={this.onPosibleNextLifeCycleClick}
        onNextLifeCycleClick={this.onNextLifeCycleClick}
        onChange={this.onChange}
        onSave={this.onSave}
        disabled={this.state.disabled}
        disabledInitialState={this.state.disabledInitialState}
        validationRules={validationRules.lifeCycle}
      />
    );
  }
}

export default withKeycloak(LifeCycleContainer);
